import type { JSX } from 'solid-js';
import { splitProps } from 'solid-js';
import { classNames } from '../lib/classes';

type Props = JSX.LabelHTMLAttributes<HTMLLabelElement>;

export function Label(props: Props) {
  const [local, rest] = splitProps(props, ['class', 'children']);
  return (
    <label
      class={classNames('block text-xs text-muted', local.class)}
      {...rest}
    >
      {local.children}
    </label>
  );
}
